import React, { useContext, useEffect, useState } from 'react'
// import AdminContext from '../../admin/StateContext/Application'
import { Form, Link } from 'react-router-dom'
import UserApplication from "../UserContext/UserContext";
import { apiurl } from '../../../path';
import './innercss.css'
import { dashboard_img } from '../../../public/LoginImages/importimages';
const ShowAuctions = () => {
    // const data = useContext(AdminContext)
    // const { GetAuctionsList } = data
    const stateCalls = useContext(UserApplication)
    const { setpaymentdata, GetAuctionsList } = stateCalls
    const [searchdata, SetSearchData] = useState([])
    const [Display, SetDisplay] = useState('none')
    const [Displayrender, SetDisplayRender] = useState([])
    const [Data, SetData] = useState([])
    useEffect(() => {
        try {
            Getdata('');
        } catch (error) {
            console.error('Error in useEffect:', error);
        }
    }, []);




    const Getdata = async (e) => {
        try {
            let data = await GetAuctionsList("getallauctions")
            // Filter out tenders with TenderWinnerStatus = "Cancel"
            let filteredData = data.filter((tender) => tender.TenderWinnerStatus !== "Cancel");

            SetSearchData(filteredData); // Store filtered data for searching
            SetData(filteredData); // Store filtered data for display
            // SetSearchData(data)
            // SetData(data)
        } catch (error) {
            console.error('Error in Getdata:', error);
        }
    }

    const Openscreen = () => {
        try {
            let lokas = document.getElementById('lokas').value
            if (lokas == 'false') {
                return
            }
            else {
                if (Display === 'none') {
                    setpaymentdata(Displayrender)
                    SetDisplay('grid')
                }
                else {
                    SetDisplay('none')
                    setpaymentdata([])
                }
            }
        } catch (error) {
            console.error('Error in Openscreen:', error);
        }

    }


    const search = (e) => {
        try {
            let searchValue = e.target.value.toLowerCase();

            if (!searchValue) {
                SetData(searchdata); // If search value is empty, show all data
                return;
            }

            let newdata = searchdata.filter((item) => {
                // Check for a match in multiple fields
                return (
                    item.PO_Number.toLowerCase().includes(searchValue) ||
                    item.Tender_Name.toLowerCase().includes(searchValue)

                );
            });

            SetData(newdata);
            console.log(newdata);
        } catch (error) {
            console.error('Error in search:', error);
        }
    }


    return (
        <div style={{ display: 'grid', flexWrap: "wrap", justifyContent: 'center', backdropFilter: "blur(1px)" }}>
            <div className="card my-5 searchTender" style={{ background: "rgba(255, 255, 255, 0.8)", border: "none", border: "1px", borderRadius: "20px" }}>
                <div className="card-body">
                    <h5 className="card-title" style={{ textAlign: "center" }}>Select Tender</h5>
                    <div className='my-3'>
                        <span>
                            <input className='form-control ' type='search' placeholder='Search Tenders by Name' onChange={(e) => { search(e) }} />
                        </span>
                    </div>
                    <div>
                        <select className='form-control' id='lokas' onChange={(e) => { SetDisplayRender(JSON.parse(e.currentTarget.value)) }} onChangeCapture={(e) => { SetDisplayRender(JSON.parse(e.currentTarget.value)); }} >
                            <option value={false}>Select Tender</option>
                            {Data && Data.map((auction, key) => {
                                return (
                                    <option key={key} className='form-control ' value={JSON.stringify(auction)} >{auction.Tender_Name}/{auction.PO_Number}
                                        {/* <button className="btn btn-success" onClickCapture={() => SetDisplayRender(auction)} onClick={(e) => { SetDisplayRender(auction); Openscreen() }}>{auction.Tender_Name}/{auction.PO_Number}</button> */}
                                    </option>
                                )
                            })}
                        </select>
                    </div>
                    <div className='my-3' style={{ display: "grid", justifyContent: "center" }}>
                        <button className='btn btn-success ' onClick={() => Openscreen()} style={{ backgroundColor: "rgb(10, 200, 150) ", border: "none" }}>Get Details</button>
                    </div>
                </div>
            </div>

            <div style={{ display: 'flex' }} id='osdsa'>
                <div style={{ position: 'absolute', top: '100%', left: '50%', transform: 'translate(-50%, -50%)', height: '100vh', width: '100vw', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', border: '1px solid #ccc', borderRadius: '10px', padding: '1rem', display: Display, backdropFilter: 'blur(1rem)', zIndex: 28 }}>
                    <div className="card mb-3 hovereffect register-pop" style={{ maxWidth: "100vw", zIndex: 25 }}>
                        <div className="row g-0" style={{ padding: "0 20px 0 20px" }}>
                            <div className="col-md-4" style={{ justifyContent: 'center', display: 'grid', alignContent: 'center' }}>
                                <div>
                                    <img src={Displayrender.Tender_Picture ? `${apiurl}/AuctionDetailsget/${Displayrender.Tender_Picture}` : "https://play-lh.googleusercontent.com/aC0eXQKKvXpCvhqDX-XZcwJQsSs8BeyQI5Nh4TPJ7G1Cs_d9w0IDNoGrhEVse2iBHJM"} className="card-img-top" alt="..." style={{ width: "10rem", height: '10rem' }} />
                                    <p><a href={`${apiurl}/AuctionDetailsget/${Displayrender.Tender_Supporting_Docs}`} target=''>View Supporting Docs</a></p>
                                    <span style={{ display: "flex" }}>
                                        <Link to={'/Dashboard/BidderRegister/' + Displayrender.Tender_ID + '/' + Displayrender.Tender_Name} ><button className='btn btn-success my-1 mx-1' style={{ backgroundColor: "rgb(10, 200, 150) ", border: "none" }}>Register</button></Link>
                                        <Link><button className='btn btn-danger my-1 mx-1' onClick={(e) => { Openscreen() }} style={{ backgroundColor: "#e73d26", border: "none" }}>Close</button></Link>
                                    </span>
                                </div>
                            </div>
                            <div className="col-md-8">
                                <div className="card-body">
                                    <h5 className="card-title">{Displayrender.Tender_Name}</h5>
                                    <span className='form-control mx-2' style={{ border: "none", background: "transparent" }}> <b>Description</b> <div>{Displayrender.Description}</div></span>
                                    <div style={{ display: 'flex', justifyContent: "center" }}>
                                        <span className='form-control mx-2' style={{ border: "none", background: "transparent" }}> <b>Contact_Information</b> <br />{Displayrender.Contact_Information}</span>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: "center" }}>
                                        <span className='form-control mx-2' style={{ border: "none", background: "transparent" }}> <b>Opening Date</b> <br />{Displayrender?.Tender_Opening_Date?.split('T')[0]}</span>
                                        <span className='form-control mx-2' style={{ border: "none", background: "transparent" }}> <b>Closing Date</b> <br />{Displayrender?.Tender_Closing_Date?.split('T')[0]}</span>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: "center" }}>
                                        <span className='form-control mx-2' style={{ border: "none", background: "transparent" }}> <b>EMD</b> <br />{Displayrender.ErnestMoneyDeposit} Rs</span>
                                        <span className='form-control mx-2' style={{ border: "none", background: "transparent" }}> <b>Tender Fee</b> <br />{Displayrender.TenderFee} Rs</span>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: "center" }}>
                                        <span className='form-control mx-2' style={{ border: "none", background: "transparent" }}> <b>PO Number</b> <br />{Displayrender.PO_Number}</span>
                                        <span className='form-control mx-2' style={{ border: "none", background: "transparent" }}> <b>GST</b> <br />{Displayrender.GST} %</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ShowAuctions